import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { orphanedResourceSchema } from '../schemas/orphaned-resource.schema';

/**
 * Gets 'orphaned' Vehicles which are not associated with an Asset
 * @returns Array of orphaned Vehicles
 */
export function getCompanyFleetsOrphan(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companyFleetsOrphanUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(z.array(orphanedResourceSchema)));
}
